import { render, staticRenderFns } from "./CardVerVotantesxLugar.vue?vue&type=template&id=90df3b08&scoped=true"
import script from "./CardVerVotantesxLugar.vue?vue&type=script&lang=js"
export * from "./CardVerVotantesxLugar.vue?vue&type=script&lang=js"
import style0 from "./CardVerVotantesxLugar.vue?vue&type=style&index=0&id=90df3b08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90df3b08",
  null
  
)

export default component.exports